import { React, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Box,
  Paper,
  useMediaQuery,
  Button
} from '@material-ui/core';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { commercialPageConstants } from '../../../../constants';


export default function SectionOne(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('md'));
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Raleway',
    },
    sectionOne: {
      backgroundColor: 'white',
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: '1.2rem',
      color: 'black',
      marginTop: '50px'

    },
    sectionOneMobile: {
      backgroundColor: 'white',
      fontSize: '.9rem',
      color: 'black',
      marginTop: '50px'

    },
    innerGridContainer: {
      width: "100%",
      margin: "0px",
      padding: "30px"
    },
    innerGridSmallHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "1rem",
      fontWeight: "bold"
    },
    innerGridHeading: {
      width: "100%",
      textAlign: "left",
      fontSize: "3rem",
      fontFamily: "sans-serif"
    },
    sectionParagraph: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".6rem",
      marginTop: '0px',
      fontWeight: 'bold'
    },
    sectionParagraphNoMarginTop: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: ".6rem",
      marginTop: '-10px',
      fontWeight: 'bold'
    },
    sectionParagraphBold: {
      // margin: "10px 0px",
      textAlign: "left",
      fontSize: "1rem",
      marginTop: '0px',
      fontWeight: 'bold'
    },
    media: {
      maxHeight: 300,
      maxWidth: 700,
      minHeight: 300,
      float: 'right',
      width: '100%'
    },
    actionButtonModal: {
      backgroundColor: "#ef6c00",
      border: "2px solid #ef6c00",
      color: "#FFF",
      textDecoration: "none",
      padding: "10px",
      fontWeight: "bold",
      fontSize: ".5rem",
      cursor: "pointer",
      "&:hover": {
        color: "#000",
      },
      width: '100px',
      height: '30px'
    },
  }));

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const handleRedirectKontaktPage = () => {
    history.push(ROUTES.KONTAKT);
    dispatch({
      type: commercialPageConstants.MENUUPDATE, payload: {
        selectedMenu: ROUTES.KONTAKT
      }
    })
  }

  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionOne : classes.sectionOneMobile}>
        <Grid container>
          <Grid item xs={2}></Grid>
          <Grid item xs={7} className={classes.innerGridContainer} container spacing={2}>
            {/* <h5 className={classes.innerGridSmallHeading}>Lorem ipsum dolor</h5> */}
            <h5 className={classes.innerGridHeading}>
              <Grid item xs={6} container>
                <p style={{ fontWeight: "lighter", textAlign: 'left', fontSize: '30px' }}>
                  Vejen til hjertet gar gennem orerne
                </p>
              </Grid>
            </h5>
            {/* <Grid container direction="row" justify="left" alignItems="left"> */}
            <Grid>
              <Grid style={{ marginTop: '5px' }}>
                <p className={classes.sectionParagraph}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
              </Grid>
              <Grid container style={{ marginTop: '40px' }}>
                <Grid xs={8}>
                  <p className={classes.sectionParagraph}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in est vel nulla varius aliquet aliquet ac ante. Ut nibh urna, posuere et risus vel, sagittis interdum diam. Nulla vitae luctus metus. Nulla vulputate eros eu purus congue, id blandit ante fringilla.
                  </p>
                  <p className={classes.sectionParagraphBold}>
                    Musik pa Hotellet
                  </p>
                  <p className={classes.sectionParagraphNoMarginTop}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam lobortis libero ligula, ac cursus massa finibus eu. Maecenas nec bibendum lectus. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer cursus, mauris eget sodales suscipit, turpis enim ultrices urna, in fringilla risus ex vitae massa. Aliquam vitae faucibus dolor. Donec nec risus augue. Vivamus at convallis eros. Donec gravida gravida est nec fringilla. Nulla ornare ornare quam ut condimentum.
                  </p>
                </Grid>
                <Grid xs={1}>

                </Grid>
                <Grid xs={3}>
                  <img src="https://www.musicminduat.dk/media/artist_covers/Musik/image1.JPG" height={'200'} width={'350'} />
                </Grid>

              </Grid>
              <Grid style={{marginTop: '-30px'}}>
                <Button className={classes.actionButtonModal} onClick={handleRedirectKontaktPage}>Kontakt Os</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </section >
    </div >
  )
}